/** @jsx jsx */
import { DefaultDropDownHeader, DropDownContext, DropDownContextProvider, DropDownWithContext, SearchList } from '@core';
import { ThemeContext } from '@emotion/core';
import { convertCountriesToListItems, SelectedCountryContext, useTranslate } from '@modules';
import { Children, Country, SxStyles } from '@types';
import React, { useContext } from 'react';
import { VscGlobe } from 'react-icons/vsc';
import { jsx, SxProps, Theme } from 'theme-ui';
import { CountryListItem } from '../finnoscore-data/List';

const styles: SxStyles = {
  dropDown: {
    width: ['100%', '100%', '400px'],
    height: 'max-content',
    boxShadow: ['none', 'none', '0 0 6px 0 rgba(0, 0, 0, 0.1)'],
    zIndex: 1,
  },
};

interface Props extends SxProps {
  countries: Country[];
  colorPickerComponent?: Children;
}

const _CountrySelector = ({ countries, colorPickerComponent, ...props }: Props) => {
  const theme = useContext(ThemeContext) as Theme;

  const { country, setCountry } = React.useContext(SelectedCountryContext);
  const { setIsOpen } = React.useContext(DropDownContext);
  const __ = useTranslate();
  const countryListItems = convertCountriesToListItems(countries);

  const onListItemSelected = (countryCode: string) => {
    const foundCountry = countryListItems.find((c) => c.id === countryCode);
    if (foundCountry) {
      setCountry({ name: foundCountry.text, countryCode: foundCountry.id });
      setIsOpen(false);
    }
  };

  return (
    <DropDownWithContext
      {...props}
      sx={{ ...styles.dropDown, ...props.sx }}
      header={
        <DefaultDropDownHeader
          title={country.name || __('finnoscore.allCountries')}
          leftComponent={
            colorPickerComponent || (
              <VscGlobe
                sx={{
                  width: '20px',
                  height: '20px',
                  color: theme.colors?.primary,
                }}
              />
            )
          }
        />
      }
    >
      <SearchList listItems={countryListItems} onSelect={onListItemSelected} selected={country.countryCode} ListItemComponent={CountryListItem} />
    </DropDownWithContext>
  );
};

export const CountrySelector = (props: Props) => (
  <DropDownContextProvider>
    <_CountrySelector {...props} />
  </DropDownContextProvider>
);
